import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./Invitation.css";
import profilePic from "../assets/illustrations/profile.png";
import {
  getScrollAnimationVariants,
  defaultScrollViewportSettings,
} from "../hooks/useScrollAnimation";
import { BOOK_CALL_URLS } from "../constants";

export default function Invitation() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.startsWith("pl") ? "pl" : "en";
  const [showDots, setShowDots] = useState(true);
  const [hasStarted, setHasStarted] = useState(false);
  const fadeInUp = getScrollAnimationVariants("fadeInUp");

  useEffect(() => {
    if (hasStarted) {
      const timer = setTimeout(() => {
        setShowDots(false);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [hasStarted]);

  return (
    <motion.section
      className="invitation-section"
      initial="hidden"
      whileInView="visible"
      onViewportEnter={() => setHasStarted(true)}
      viewport={{ ...defaultScrollViewportSettings, amount: 0.3 }}
      variants={fadeInUp}
    >
      <div className="invitation-container">
        <div className="profile-wrapper">
          <img src={profilePic} alt="Jagoda" className="profile-img" />
        </div>
        <div className="message-bubble">
          <AnimatePresence mode="wait">
            {showDots ? (
              <motion.div
                key="dots"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="dots-container"
              >
                <span className="dot">.</span>
                <span className="dot">.</span>
                <span className="dot">.</span>
              </motion.div>
            ) : (
              <motion.div
                key="text"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                className="bubble-content"
              >
                <span className="message-text">{t("invitation.message")}</span>
                <a
                  href={BOOK_CALL_URLS[lang]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bubble-arrow-btn"
                  aria-label="Contact us"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="7" y1="17" x2="17" y2="7"></line>
                    <polyline points="7 7 17 7 17 17"></polyline>
                  </svg>
                </a>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </motion.section>
  );
}
